import React from 'react';
import Link from 'gatsby-link';

// const Navbar = () => (
//   <nav css={styles.navbar}>
//     <Link to="/">
//       Bla
//     </Link>
//   </nav>
// );

// export default Navbar;
export default () => null;

const styles = {
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
  },
};



// WEBPACK FOOTER //
// ./src/partials/navbar.js